var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: 540,
    y1: 1038.03,
    x2: 540,
    y2: 41.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8399b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff488f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.97,
    y: 41.97,
    width: 996.05,
    height: 996.05,
    rx: 273.3,
    fill: "url(#Degradado_sin_nombre_10)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M741.1,718.11c0,9.8,0,19.39,0,29C741,757.25,735,763.34,725,763.38q-21.13.07-42.26,0c-9.75,0-15.86-6.21-15.92-16-.06-9,0-18,0-26.93a10.27,10.27,0,0,0-.21-1.27H503.31v22.92c0,2.32.08,4.65,0,7-.41,7.88-6.44,14.15-14.34,14.25q-22.74.3-45.5,0a14.56,14.56,0,0,1-14.34-13.75c-.27-5.07,0-10.17,0-15.58h14.64v14.17h44.46V718.81H472c-11.46,0-22.91,0-34.36,0-18.17-.09-30.83-12.82-30.88-31.09q-.08-26.93,0-53.86c.06-17.51,10.82-30.53,28-33.47,3.12-.53,4.35-1.78,5.28-4.59q13.9-42.27,28-84.46c5.24-15.73,15.19-22.88,31.92-22.88H670.36c16.58,0,26.47,7.2,31.76,23.09q14,42,27.92,84c1,2.92,2.21,4.31,5.56,4.88,16.92,2.89,27.7,15.92,27.77,33.16.08,16.87-.31,33.75.12,50.61C763.91,700.71,757.36,712.21,741.1,718.11ZM585.23,703.94H731.45c11.33,0,17.06-5.79,17.08-17.2q0-26.22,0-52.45c0-12.06-7.35-19.5-19.28-19.5q-144.15,0-288.28,0c-12,0-19.35,7.41-19.38,19.4,0,17.33,0,34.66,0,52,0,12.25,5.56,17.77,17.89,17.77Zm-131-104.26H715.66c-.52-1.76-.92-3.23-1.39-4.67q-8.19-24.64-16.41-49.26c-1.37-4.1-1.73-9.78-4.61-11.79-3.06-2.13-8.56-.9-13-.91q-99.6,0-199.19-.1c-3.55,0-5.05,1-6.13,4.38-4.66,14.73-9.66,29.35-14.54,44C458.4,587.33,456.4,593.31,454.28,599.68Zm27.84-81.74H688c-1.34-9.38-6.85-14.59-15.71-14.6q-87.28-.07-174.56,0C488.9,503.35,483.28,508.71,482.12,517.94ZM681.86,748.2h44V719.05h-44Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M570,473.37h-14.7v-5.63q0-58.75,0-117.49c0-12.31-5.53-17.85-17.82-17.85H350.36c-12.38,0-18,5.5-18,17.71V537.72c0,12,5.64,17.6,17.61,17.6h78.7V570c-1,.06-1.9.15-2.78.15-26,0-52,.08-78,0-17.55-.06-30.33-13-30.35-30.66q-.09-76.86,0-153.71c0-12.38,0-24.77,0-37.15.06-18.32,12.67-31.08,30.86-31.09q95.67-.06,191.33,0c17.2,0,30.34,12.72,30.39,29.65.14,41.18,0,82.35,0,123.53C570.18,471.49,570.1,472.25,570,473.37Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M421.57,481c0,16.94,0,33.18,0,49.41,0,7.61-2.4,10-9.95,10q-20,0-39.92,0c-7,0-9.57-2.53-9.57-9.46q0-87,0-174.08c0-7.22,2.49-9.65,9.83-9.65,28.79,0,57.57-.08,86.35,0,35.17.12,63.13,25.47,67.05,60.65,3.68,33-19.31,64.28-52.9,71.55A81,81,0,0,1,456.81,481C445.24,481.16,433.67,481,421.57,481ZM377.32,362.27v163.1h29.39v-4.75q0-22,0-44.12c0-8.15,2.25-10.33,10.55-10.34,14.39,0,28.8.23,43.19-.11,26.08-.63,47.38-20.84,50.1-47.13,2.59-25-14.21-48.81-38.84-55a36.49,36.49,0,0,0-8.65-1.54C434.59,362.23,406.13,362.27,377.32,362.27Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M511,637.29H659v14.34H511Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M510.94,681.32V667H659.13v14.28Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.87,659.56a29.72,29.72,0,1,1-29.65-29.92A29.8,29.8,0,0,1,495.87,659.56Zm-29.91-15a14.84,14.84,0,1,0,15,14.53A14.91,14.91,0,0,0,466,644.52Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M733.65,659.53A29.71,29.71,0,1,1,704,629.64,29.79,29.79,0,0,1,733.65,659.53Zm-14.87-.36a14.84,14.84,0,1,0-14.54,15A14.91,14.91,0,0,0,718.78,659.17Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M437.83,391.85c7,0,13.93-.09,20.89,0a22.26,22.26,0,1,1-.06,44.52c-14.39.14-28.78.08-43.17,0-6,0-8.72-2.75-8.76-8.84q-.11-13.47,0-26.92c0-6.07,2.73-8.74,8.82-8.79C423,391.8,430.4,391.85,437.83,391.85Zm-16,14.92v14.74c12.7,0,25.16.14,37.62-.08a7,7,0,0,0,6.64-7.52c-.28-4.07-2.62-7-6.63-7C447,406.6,434.53,406.77,421.82,406.77Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEst);
export default __webpack_public_path__ + "static/media/icon-est.6667500c6795d595191e450091d021f7.svg";
export { ForwardRef as ReactComponent };